import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dm_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const submitInquiry = async (payload) => {
  const { data } = await api.post("/inquiries", payload);
  return data;
};

export const getContent = async () => {
  const { data } = await api.get("/content");
  return data || {};
};

export const updateContent = async (payload) => {
  const { data } = await api.put("/content", payload);
  return data;
};

export const adminLogin = async (username, password) => {
  const { data } = await api.post("/admin/login", { username, password });
  return data;
};

export const adminMe = async () => {
  const { data } = await api.get("/admin/me");
  return data;
};

export const listInquiries = async () => {
  const { data } = await api.get("/inquiries");
  return data;
};
